import { render, staticRenderFns } from "./AutoRequisitionProcess.vue?vue&type=template&id=5616a448&scoped=true"
import script from "./AutoRequisitionProcess.vue?vue&type=script&lang=js"
export * from "./AutoRequisitionProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5616a448",
  null
  
)

export default component.exports